




import { Component, Vue } from "vue-property-decorator";
import Auth from "@/state/Auth";
import { Role } from "@/constants/Role";
import PrilInitialProcessing from "@/components/pril/PRILInitialProcessing.vue";
import Pril from "@/components/pril/PRIL.vue";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import {processError} from "@/utils/ComponentUtils";
import PRIL_DTO from "@/dto/request/pril/PRIL_DTO";
import {PRILStatus} from "@/constants/request/PRILConstants";

@Component({})
export default class PostalRegisterRecord extends Vue {

  private pril = new PRIL_DTO();

  mounted() {
    this.loadPRIL();
  }

  loadPRIL(): void {
    Application.startLoading();
    PRILService.getLetterById(this.prilId).then(
        resp => {
          this.pril = resp.data;
          Application.stopLoading();
        },
        error => processError(error, this)
    )
  }

  get prilId(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get currentTypePostal(): typeof PrilInitialProcessing | typeof Pril {
    if (this.pril.status == PRILStatus.NEW && Auth.hasPermission(Role.PRIL_MANAGER)) {
      return PrilInitialProcessing;
    } else {
      return Pril;
    }
  }

}

